import { combineReducers } from "redux";
import audioPlayerReducer from "./audioPlayer";
import searchReducer from "./search";

export default combineReducers({
  audioPlayer: audioPlayerReducer,
  searchResults: searchReducer
});
